export * from "./menu-tile-carousel.component";
